import { useCallback } from "react";
import { CUSTOM_TEXT_MAX_LENGTH } from "@/utils/constants";
import {
  StyledContainer,
  StyledTitle,
  StyledHint,
  StyledTextarea,
  StyledCharCount,
  StyledTitleNumber,
  StyledTitleContainer,
  StyledContentContainer,
} from "./CustomText.styles";

export type CustomTextProps = {
  number: number;
  title: string;
  value: string;
  onChange: (value: string) => void;
};

const CustomText = ({ number, title, value, onChange }: CustomTextProps) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newValue = e.target.value;
      if (newValue.length <= CUSTOM_TEXT_MAX_LENGTH) {
        onChange(newValue);
      }
    },
    [onChange]
  );

  const currentLength = value.length;

  return (
    <StyledContainer>
      <StyledTitleContainer>
        <StyledTitleNumber>{number} </StyledTitleNumber>
        <StyledTitle>{title}</StyledTitle>
      </StyledTitleContainer>
      <StyledContentContainer>
        <StyledHint>貼入希望出題的主題方向或素材｜非必填</StyledHint>
        <StyledTextarea
          value={value}
          onChange={handleChange}
          placeholder="可填入時事內容、社會及生活議題、閱讀文本等，AI 將根據您提供的內容，結合所選的課程範圍與素養能力，生成相應的試題。"
          maxLength={CUSTOM_TEXT_MAX_LENGTH}
        />
        <StyledCharCount>
          目前{currentLength}字 / 最多{CUSTOM_TEXT_MAX_LENGTH}字
        </StyledCharCount>
      </StyledContentContainer>
    </StyledContainer>
  );
};

export default CustomText;
